<template>
  <div class="scrollable">
    <v-header></v-header>
    <div class="content" style="margin-bottom:70px;">
      <div class="breadNav">
        <p>
          <span>健康管理 > 体检报告 > 疾病风险评估</span>
        </p>
      </div>
      <div class="msg">
        <div class="tit">
          <p>根据大数据分析，您患心血管疾病的风险为：</p>
          <p v-if="$route.query.score === '低危'" style="color:#11BA06;">{{$route.query.score}}</p>
          <p v-if="$route.query.score === '中危'" style="color:#F5A623;">{{$route.query.score}}</p>
          <p v-if="$route.query.score === '高危'" style="color:#e94709;">{{$route.query.score}}</p>
          <p v-if="$route.query.score === '无评估结果'" style="color:#333;">{{$route.query.score}}</p>
        </div>
        <div class="div1">
          <p>中国成人血脂异常防治指南修订联合委员会（包括国家心血管病中心国家心血管病专家委员会、中华医学会心血管病学分会、中华医学会糖尿病学分会等）发布了《中国成人血脂异常防治指南（2016 年修订版）》，此指南公布了总体心血管危险评估流程（动脉粥样硬化性心血管疾病危险评估流程图）。根据总体心血管危险评估流程对您心血管疾病危险进行评估。</p>
        </div>
        <div style="margin-top:30px;">
          <el-progress v-if="$route.query.score != '无评估结果'" :percentage="100" :show-text="false"></el-progress>
          <div style="display:flex;justify-content: space-between;">
            <div style="text-align:center;width:60px;">
              <p  v-if="$route.query.score==='低危'" style="margin-left:10px;text-align:center;width: 0;height: 0;border: 20px solid;border-color: transparent transparent #11BA06;"></p>
              <p  v-if="$route.query.score==='低危'" style="text-align:center;font-size:18px;line-height:20px;margin-top:10px;">{{$route.query.score}}</p>
            </div>
            <div style="text-align:center;width:60px;" >
              <p  v-if="$route.query.score==='中危'" style="margin-left:10px;text-align:center;width: 0;height: 0;border: 20px solid;border-color: transparent transparent #F5A623;"></p>
              <p  v-if="$route.query.score==='中危'" style="text-align:center;font-size:18px;line-height:20px;margin-top:10px;">{{$route.query.score}}</p>
            </div>
            <div style="text-align:center;width:60px;" >
              <p  v-if="$route.query.score==='高危'" style="margin-left:10px;text-align:center;width: 0;height: 0;border: 20px solid;border-color: transparent transparent #e94709;"></p>
              <p  v-if="$route.query.score==='高危'" style="text-align:center;font-size:18px;line-height:20px;margin-top:10px;">{{$route.query.score}}</p>
            </div>
          </div>
        </div>
        <div style="margin-top:30px;" v-if="$route.query.score==='低危'">
          <p style="font-size:18px;line-height:20px;color:#333;">健康建议指导如下：</p>
          <p style="margin-top:10px;font-size:18px;line-height:30px;color:#333;">研究ASCVD的宗旨就是降低患者终生心血管事件风险。逆转ASCVD发病上升关键在于一级预防。生活方式干预和血脂管理是.ASCVD防治的两大基石。低、中ASCVD风险、血脂未达标患者进行生活方式干预作为初始的治疗方法。</p>
        </div>
        <div style="margin-top:30px;" v-if="$route.query.score==='中危'">
          <p style="font-size:18px;line-height:20px;color:#333;">健康建议指导如下：</p>
          <p style="margin-top:10px;font-size:18px;line-height:30px;color:#333;">根据2016年HOPE-3研究对于ASCVD中危人群,建议在改善生活方式的基础上,建议及早启动他汀药物治疗。</p>
        </div>
        <div style="margin-top:30px;" v-if="$route.query.score==='高危'">
          <p style="font-size:18px;line-height:20px;color:#333;">健康建议指导如下：</p>
          <p style="margin-top:10px;font-size:18px;line-height:30px;color:#333;">对于ASCVD高危和极高危的患者,初次就诊时就应开始中小强度他汀药物治疗,同时进行生活方式干预。对于ASCVD急性发作病例推荐紧急血管再通,同时双抗（抗聚治疗与抗凝治疗）+高强度他汀。</p>
        </div>
      </div>
      <div @click="goback" style=" margin:0 auto;margin-top:127px;cursor: pointer;width:180px;height:46px;background:#FF000F;color:#fff;display:flex;justify-content: center;align-items: center;border-radius: 23px;">
        <p style="font-size:16px;line-height:16px;">返回</p>
      </div>
    </div>
    <v-footer></v-footer>
  </div>
</template>

<script>
    import header from "../../common/header.vue";
    import footer from "../../common/footer.vue";
    export default {
        name: "appraise",
        data() {
            return {};
        },
        components: {
            "v-header": header,
            "v-footer": footer
        },
        created() {},
        methods: {
            goback() {
                this.$router.go(-1)
            }
        }
    };
</script>

<style scoped lang="scss">
    .msg {
        width: 1180px;
        margin: 0 auto;
        padding: 50px 0 50px 0;
        .tit {
            text-align: center;
            display: flex;
            justify-content: center;
            p:nth-child(1) {
                font-size: 24px;
                font-weight: 600;
                color: #333;
                line-height: 24px;
            }
            p:nth-child(2) {
                font-size: 24px;
                font-weight: 600;
                color: #f5a623;
                line-height: 24px;
            }
        }
        .div1 {
            font-size: 18px;
            font-weight: 400;
            color: #333;
            line-height: 30px;
            margin-top: 50px;
        }
    }
    
    .breadNav {
        width: 100%;
        height: 80px;
        border-bottom: 2px solid #eaeaea;
        display: flex;
        align-items: center;
        p {
            width: 1180px;
            margin: 0 auto;
            font-size: 18px;
            font-weight: 600;
            color: #333;
            line-height: 20px;
            display: flex;
            justify-content: space-between;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/phyExServices/medicalReports/appraise.vue